import { noopLogger } from '../noopLogger';
var Storage = (function () {
    function Storage(config, logger) {
        if (config === void 0) { config = {}; }
        this.logger = logger || noopLogger;
        this.config = config;
        this.accessTokenName = config.accessTokenName || 'accessToken';
        this.refreshTokenName = config.refreshTokenName || 'refreshToken';
        if (config.logLevel) {
            this.logger.setLevel(config.logLevel);
        }
    }
    Storage.isSupported = function () {
        throw new Error('Is not implemented');
    };
    Storage.prototype.removeTokens = function () {
        throw new Error('Is not implemented');
    };
    Storage.prototype.getTokens = function () {
        return {
            accessToken: this.getAccessToken(),
            refreshToken: this.getRefreshToken()
        };
    };
    Storage.prototype.setTokens = function (tokens) {
        this.setAccessToken(tokens.accessToken);
        this.setRefreshToken(tokens.refreshToken);
    };
    return Storage;
}());
export { Storage };
//# sourceMappingURL=Storage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/keycloak/es/storages/Storage.js
// module id = 342
// module chunks = 118